@if (!networkStatus.isOnline()) {
  <div class="flex items-center justify-center gap-2 bg-amber-500 px-4 py-2 text-sm font-medium text-white">
    <mat-icon class="icon-size-5 shrink-0" svgIcon="heroicons_outline:wifi"></mat-icon>
    <span>You're offline — changes will sync when you reconnect.</span>
  </div>
}
